<template>
  <div>
     
    <Evaluacion  :receivedValue="evaluationValueReceived" :flagEvalGroup=true :levels="lists.levels"   @listenChild="evaluationValueChild" @listenLevel="evaluationLevelChild" />
      
  </div>
</template>



<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import Evaluacion from '@/views/compra/evaluacion.vue'

export default {
  components:{
    Evaluacion
  },
  data(){

	return{
      lang:localStorage.getItem('lang') || 'es',
      API_URL: process.env.VUE_APP_API_URL,
      evaluationValueReceived: {
        personStudentId: 0,
        level:{id:0}
      },
      //courseValueReceived: null,
      group: {
        id: 0,
        groupPerson: {
          groupPersonId: 0,
          personStudent: {
            id: 0,
            levelId: 0,
            age:0,
            planSelected:{
                planPriceId:0,
                planPriceTypeId:0,
            },
            goalSelected:{ 
                id:0,
            },
            examSelected:{
               name: '',
               id: 0,
               programId: 0
            } 
          },
          groupPersonEvaluation: {
              evaluationId: 0,
              evaluation: {
					id:0,
           	 	 	name:'',
           	 	 	duration:0,
			  },
              duration: 0,
              timeDuration:'00:00:00',
              score: 0,
              questionAnswerSelected: []
          }
        },
        
        //groupCourses: []
      },
      lists:{
        goals:[],
        levels:[]
      }
    }
  },
  mounted(){
    if(this.User != null){
      this.getLogin(); 
    }
    this.getLevels();
    
     
  },
  created() {
    
  },
  watch:{
   
  },
  computed: {
    UserId: {
      get() {
          return this.$store.state.user_id;
      },
    },
    User: {
      get() {
          return this.$store.state.user;
      },
      set(value) {
          this.$store.commit('mutateUser', value);
      }
    },
    DatosSidebar: {
      get() {
          return this.$store.state.datosSidebar;
      }
    },
  },
  methods:{
    getLogin: function(){
    
      this.evaluationValueReceived.personStudentId = this.User.personStudentId;
      this.group.groupPerson.personStudent.age = this.User.age;
      this.group.groupPerson.personStudent.id = this.User.personStudentId;
      this.group.id = this.$store.state.group_id;
      this.group.groupPerson.groupPersonId = this.$store.state.group_person_id;
      
    },
    getLevels: function() {
      let flag = this.lang == 'es' ? true : false;
      baseInstanceAxios
        .get(this.API_URL + `/resources/levelsfeatures/getbylevels?flagLanguage=${flag}` )
        .then(response => {
          if(response.data != null && response.data.list != null){
						this.lists.levels = response.data.list;
			    }
      });
    },
   
    evaluationLevelChild(level){
      this.group.groupPerson.personStudent.levelId = level.id;
    },
    evaluationValueChild(data) {
      this.group.groupPerson.groupPersonEvaluation.questionAnswerSelected = data.listAnswersSelecteds;
      this.group.groupPerson.groupPersonEvaluation.evaluation = data.evaluation;
      this.group.groupPerson.groupPersonEvaluation.timeDuration = data.timeDuration;
      this.group.groupPerson.groupPersonEvaluation.duration = data.duration;
      let exam = null;
      if (this.group.groupPerson.personStudent.examSelected.id > 0) {
       exam = this.group.groupPerson.personStudent.examSelected.id;
      }
      //debugger;
      let evalutionExecute ={
        questionAnswerSelected: data.listAnswersSelecteds,
        groupPersonId: this.group.groupPerson.groupPersonId,
        evaluationId: this.group.groupPerson.groupPersonEvaluation.evaluation.id,
        duration: this.group.groupPerson.groupPersonEvaluation.duration,
        timeDuration: this.group.groupPerson.groupPersonEvaluation.timeDuration,
        goalId:this.group.groupPerson.personStudent.goalSelected.id,
        planPriceId:this.group.groupPerson.personStudent.planSelected.planPriceId,
        typePlanPriceId:this.group.groupPerson.personStudent.planSelected.planPriceTypeId,
        personStudentId:this.evaluationValueReceived.personStudentId, 
        age:this.group.groupPerson.personStudent.age, 
        subjectId:exam
      }
      baseInstanceAxios
					.post(this.API_URL + `/Resources/GroupsPersonsEvaluations/SendEvaluation`, evalutionExecute)
					.then(response => {
            
						if ( response.data != null && response.data.return ) {
              var personStudentId = this.evaluationValueReceived.personStudentId;
              this.evaluationValueReceived = response.data.entity;
              this.evaluationValueReceived.personStudentId= personStudentId;
              this.group.groupPerson.personStudent.levelId = this.evaluationValueReceived.level.id;

              this.$store.commit('mutateGroupPersonId', response.data.entity.groupPersonId);
               

              this.$forceUpdate();
						}else{
              console.log(response.data.message);
            }
					})
          .catch(function (error) {
              console.log(error);
              
          });;
    },
 
  },
 
}
</script>